import customTheme from '~/styles/theme';

export const cellContainer = {
  minHeight: '32px',
  height: '100%',
  display: 'grid',
  alignItems: 'center',
};

export const tdProps = {
  borderWidth: '0px 0px 1px 0px',
  borderStyle: 'solid',
  borderColor: customTheme.colors.primary['100'],

  _first: {
    left: 0,
  },
};
